import { styled } from '@mui/material/styles';
export const TitleLabel = styled('p')(() => ({
  fontWeight: 700,
  marginTop: 0
}));

export const BlockLabel = styled('p')(() => ({
  fontWeight: 700,
  textDecoration: 'underline'
}));
